import React, { Component } from 'react';
import './Home.scss';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import StoreIcon from '@material-ui/icons/Store';
import PersonIcon from '@material-ui/icons/Person';
import StorageIcon from '@material-ui/icons/Storage';
import CategoryIcon from '@material-ui/icons/Category';
import PaymentIcon from '@material-ui/icons/Payment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InputIcon from '@material-ui/icons/Input';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PublishIcon from '@material-ui/icons/Publish';
import InfoIcon from '@material-ui/icons/Info';
import SettingsIcon from '@material-ui/icons/Settings';
import DashboardIcon from '@material-ui/icons/Dashboard';
import RoomIcon from '@material-ui/icons/Room';

const APP_VERSION = '68';
const VERSION_DATE = '5/16/2026';

export default class Home extends Component {
    state = {
        showVersion: false,
    };

    hasPermission = (permissions, name) =>
        permissions.some((x) => x.PermissionName === name && x.PermissionAllowed === 1);

    renderCardContent = (card, nested = false) => {
        const IconComponent = card.Icon;
        return (
            <Card className={nested ? 'home-card home-card--nested' : 'home-card'}>
                <CardContent>
                    {IconComponent && (
                        <div className="home-card-icon-wrap">
                            <IconComponent className="home-card-icon" />
                        </div>
                    )}
                    <Typography className="home-card-title" variant="h6" component="div">
                        {card.title}
                    </Typography>
                    <Typography className="home-card-description" color="textSecondary">
                        {card.description}
                    </Typography>
                </CardContent>
            </Card>
        );
    };

    renderDashboardCard = (card, nested = false) => {
        const gridProps = nested
            ? { xs: 12, sm: 6, md: 3 }
            : { xs: 12, sm: 6, md: 4 };

        if (card.action === 'version') {
            return (
                <Grid item {...gridProps} key={card.id}>
                    <div
                        className="home-card-link"
                        onClick={() => this.setState({ showVersion: true })}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                this.setState({ showVersion: true });
                            }
                        }}
                    >
                        {this.renderCardContent(card, nested)}
                    </div>
                </Grid>
            );
        }

        return (
            <Grid item {...gridProps} key={card.id}>
                <Link to={card.route} className="home-card-link">
                    {this.renderCardContent(card, nested)}
                </Link>
            </Grid>
        );
    };

    render() {
        sessionStorage.setItem('TranSearch', null);
        sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
        const user = JSON.parse(sessionStorage.getItem('user'));
        const permissions = user.permissions;
        const cardData = [
            {
                id: 'user-dashboard',
                title: 'My Dashboard',
                description: 'Operational and sales summary for your account',
                route: '/user-dashboard',
                Icon: DashboardIcon,
            },
        ];
        const configCardData = [];

        if (this.hasPermission(permissions, 'User')) {
            configCardData.push({
                id: 'config-user',
                title: 'User Administration',
                description: 'User Administration',
                route: '/user-form',
                Icon: SupervisedUserCircleIcon,
            });
        }
        if (this.hasPermission(permissions, 'Payment Method')) {
            configCardData.push({
                id: 'config-payment',
                title: 'Payment Method',
                description: 'View and Export Current Payment Method',
                route: '/payment-method',
                Icon: PaymentIcon,
            });
            configCardData.push({
                id: 'config-commission',
                title: 'Commission',
                description: 'Add and manage commission settings',
                route: '/commission',
                Icon: MonetizationOnIcon,
            });
        }
        if (this.hasPermission(permissions, 'Item Category')) {
            configCardData.push({
                id: 'config-entity-group',
                title: 'Entity Groups',
                description: 'Manage invoice line item groups',
                route: '/entity-group',
                Icon: CategoryIcon,
            });
            configCardData.push({
                id: 'config-category',
                title: 'Item Category',
                description: 'View and Export Current Item Category',
                route: '/item-category',
                Icon: CategoryIcon,
            });
        }
        if (this.hasPermission(permissions, 'Inventory')) {
            configCardData.push({
                id: 'config-item-location',
                title: 'Item Locations',
                description: 'Manage item location names',
                route: '/item-location',
                Icon: RoomIcon,
            });
            configCardData.push({
                id: 'config-location-details',
                title: 'Location Details',
                description: 'View item quantities by location',
                route: '/location-details',
                Icon: RoomIcon,
            });
        }
        configCardData.push({
            id: 'config-version',
            title: 'Version',
            description: 'Application version',
            action: 'version',
            Icon: InfoIcon,
        });

        if (this.hasPermission(permissions, 'Vendor')) {
            cardData.push({
                id: 'vendor',
                title: 'Vendors',
                description: 'View and Add Vendors',
                route: '/vendor-form',
                Icon: StoreIcon,
            });
        }
        if (this.hasPermission(permissions, 'Customer')) {
            cardData.push({
                id: 'customer',
                title: 'Customer Form',
                description: 'View And Add customer',
                route: '/customer-form',
                Icon: PersonIcon,
            });
        }
        if (this.hasPermission(permissions, 'Inventory')) {
            cardData.push({
                id: 'inventory',
                title: 'Inventory',
                description: 'View and Export Current Inventory',
                route: '/item-form',
                Icon: StorageIcon,
            });
            cardData.push({
                id: 'inventory-transfer',
                title: 'Inventory Transfer',
                description: 'Transfer item quantities between locations',
                route: '/inventory-transfer',
                Icon: StorageIcon,
            });
        }
        if (this.hasPermission(permissions, 'Transaction')) {
            cardData.push({
                id: 'transactions',
                title: 'Transactions',
                description: 'view transaction',
                route: '/transactions',
                Icon: ReceiptIcon,
            });
        }
        if (this.hasPermission(permissions, 'InTake Product')) {
            cardData.push({
                id: 'intake',
                title: 'Product Intake',
                description: 'Intake Products',
                route: '/intake',
                Icon: InputIcon,
            });
        }
        if (this.hasPermission(permissions, 'Check Out Product')) {
            cardData.push({
                id: 'checkout',
                title: 'Product Check Out',
                description: 'Check Out Products',
                route: '/CheckOut',
                Icon: ShoppingCartIcon,
            });
        }
        if (this.hasPermission(permissions, 'Reports')) {
            cardData.push({
                id: 'reports',
                title: 'Reports',
                description: 'Reports',
                route: '/Reports',
                Icon: AssessmentIcon,
            });
        }
        if (this.hasPermission(permissions, 'Imports')) {
            cardData.push({
                id: 'imports',
                title: 'Imports',
                description: 'Imports',
                route: '/Imports',
                Icon: PublishIcon,
            });
        }

        const { showVersion } = this.state;

        return (
            <div className="home-page">
                <Typography variant="h5" className="home-title">
                    Dashboard
                </Typography>
                <Grid container spacing={3}>
                    {cardData.map((card) => this.renderDashboardCard(card))}

                    {configCardData.length > 0 && (
                        <Grid item xs={12}>
                            <Card className="home-config-group">
                                <CardContent>
                                    <div className="home-config-header">
                                        <SettingsIcon className="home-config-header-icon" />
                                        <Typography variant="h6" className="home-config-header-title">
                                            Configuration
                                        </Typography>
                                    </div>
                                    <Grid container spacing={2}>
                                        {configCardData.map((card) =>
                                            this.renderDashboardCard(card, true)
                                        )}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                </Grid>

                <Dialog
                    open={showVersion}
                    onClose={() => this.setState({ showVersion: false })}
                    aria-labelledby="version-dialog-title"
                    aria-describedby="version-dialog-description"
                >
                    <DialogTitle id="version-dialog-title">Application Version</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="version-dialog-description">
                            <div>Version : {APP_VERSION}</div>
                            <div>Date : {VERSION_DATE}</div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({ showVersion: false })}
                            color="primary"
                            autoFocus
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
